import React, {useEffect, useState} from 'react';
import './FollowUpList.scss';
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import Loader from "../Loader";
import {toast} from "react-toastify";
import NumericFunction from "../../utils/NumericFunction";
import ModalDetailFollowUp from "./ModalDetailFollowUp";
import {useLocation} from "react-router-dom";
import ModalFollowUp from "./ModalFollowUp";
import ModalCheckOut from "./ModalCheckOut";
import ModalCheckDelete from "./ModalCheckDelete";

const FollowUpList = () => {

    const [initialData, setInitialData] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [followUpId, setFollowUpId] = useState("");
    const [reRender, setReRender] = useState(1);
    const [classNameBox, setClassNameBox] = useState("");
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showFollowUpModal, setShowFollowUplModal] = useState(false);
    const [dataDetailModal, setDataDetailModal] = useState({});
    const [showSmallModal, setShowSmallModal] = useState(false)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [requestSmallModal, setRequestSmallModal] = useState(0)
    const [requestDeleteModal, setRequestDeleteModal] = useState(0)
    const location = useLocation();

    useEffect(() => {
        if (location.state.listName !== null && location.state.pkValue !== null) {
            _axios.get(prefixUrl() + "/followUp/?request=tableRecordFollowUps&listName=" + location.state.listName + "&pkValue=" + location.state.pkValue)
                .then(response => {
                    if (response.data.status) {
                        setInitialData(response.data.tableRecordFollowUps)
                        setIsLoad(true)
                    }
                })
        }
    }, [reRender, location.state.listName, location.state.pkValue])

    useEffect(() => {

        if (requestDeleteModal !== 0) {
            _axios.delete(prefixUrl() + "/followUp/?request=deleteFollowUp&followUpId=" + followUpId)
                .then((res) => {
                    if (res.data.status) {
                        toast.success(res.data.message)
                        setReRender(reRender + 1);
                        setFollowUpId("");
                        setShowDeleteModal(false)
                    } else {
                        toast.success(res.data.message)
                    }
                });
        }
    }, [requestDeleteModal])

    const deleteHandler = () => {

        if (followUpId !== "") {
            setShowDeleteModal(true)
        } else {
            toast.error("پیگیری مورد نظر را انتخاب کنید")
        }
    }

    const clickBoxHandler = (e, v) => {
        setFollowUpId(v?.CODE_FW)
        setClassNameBox(e.currentTarget.id)
        setDataDetailModal({
            ...dataDetailModal,
            KMO: v.KMO,
            DDATE: v.DDATE,
            TTIME: v.TTIME,
            AC: v.AC,
            BC: v.BC,
            CC: v.CC
        })
    }

    const detailHandler = () => {
        if (followUpId !== "") {

            _axios.get(prefixUrl() + "/followUp/?request=followUpDetails&followUpId=" + followUpId)
                .then((response) => {
                    if (response.data.status) {
                        setDataDetailModal({...dataDetailModal, followUpDetails: response.data.followUpDetails})
                        setShowDetailModal(true)
                    } else {
                        toast.error(response.data.message);
                    }
                });
        } else {
            toast.error("پیگیری مورد نظر را انتخاب کنید")
        }
    }

    useEffect(() => {

        if (requestSmallModal !== 0) {
            _axios.post(prefixUrl() + "/followUp/?request=setFollowUpToFinished&followUpId=" + followUpId)
                .then(response => {
                    if (response.data.status) {
                        toast.success(response.data.message)
                        setShowSmallModal(false)
                        setReRender(reRender + 1)
                    }
                })
        }
    }, [requestSmallModal])

    const endTrackingHandler = () => {
        if (followUpId !== "") {
            setShowSmallModal(true)
        } else {
            toast.error("پیگیری مورد نظر را انتخاب کنید")
        }
    }

    return (
        <>
            {showDetailModal &&
                <ModalDetailFollowUp dataDetailModal={dataDetailModal}
                                     onClose={() => setShowDetailModal(false)}/>}
            {showFollowUpModal &&
                <ModalFollowUp listName={location.state.listName}
                               pkValue={location.state.pkValue}
                               setShowModal={setShowFollowUplModal}
                               setReRender={setReRender}
                               onClose={() => setShowFollowUplModal(false)}/>}

            {showSmallModal &&
                <ModalCheckOut setShowSmallModal={setShowSmallModal}
                               setRequestSmallModal={setRequestSmallModal}
                               onClose={() => setShowSmallModal(false)}/>}

            {showDeleteModal &&
                <ModalCheckDelete setShowDeleteModal={setShowDeleteModal}
                               setRequestDeleteModal={setRequestDeleteModal}
                               onClose={() => setShowDeleteModal(false)}/>}


            {isLoad ?
                <div className="main-flow-up-list">
                    {initialData.length > 0 ?
                        <div className="box-follow-side" id={"ListScroll"}>
                            {initialData.map((v, index) =>
                                <div
                                    className={`box-follow-up ${classNameBox === v?.CODE_FW ? "box-follow-up-green" : ""}`}
                                    id={v?.CODE_FW} key={"Fl" + index}
                                    onClick={(e) => clickBoxHandler(e, v)}>

                                    <div className="top-box">

                                        <p>کاربر ارسال کننده : {v?.KMO}</p>

                                        <p>تاریخ ارسال : {NumericFunction.e2p(v?.DDATE + " - " + v?.TTIME)}</p>

                                        <div className="inline-type">

                                            <div className="one-svg-box">
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_769_518)">
                                                        <path
                                                            d="M5.62441 11.0937C5.36816 11.0937 5.15566 10.8812 5.15566 10.625V8.00624L4.70566 8.45624C4.52441 8.63749 4.22441 8.63749 4.04316 8.45624C3.86191 8.27499 3.86191 7.97499 4.04316 7.79374L5.29316 6.54374C5.42441 6.41249 5.63066 6.36874 5.80566 6.44374C5.98066 6.51249 6.09316 6.68749 6.09316 6.87499V10.625C6.09316 10.8812 5.88066 11.0937 5.62441 11.0937Z"
                                                            fill="#1B9C85"/>
                                                        <path
                                                            d="M6.87445 8.59368C6.7557 8.59368 6.63695 8.54993 6.5432 8.45618L5.29316 7.20618C5.11191 7.02493 5.11191 6.72493 5.29316 6.54368C5.47441 6.36243 5.77441 6.36243 5.95566 6.54368L7.2057 7.79368C7.38695 7.97493 7.38695 8.27493 7.2057 8.45618C7.11195 8.54993 6.9932 8.59368 6.87445 8.59368Z"
                                                            fill="#1B9C85"/>
                                                        <path
                                                            d="M9.375 14.2188H5.625C2.23125 14.2188 0.78125 12.7688 0.78125 9.375V5.625C0.78125 2.23125 2.23125 0.78125 5.625 0.78125H8.75C9.00625 0.78125 9.21875 0.99375 9.21875 1.25C9.21875 1.50625 9.00625 1.71875 8.75 1.71875H5.625C2.74375 1.71875 1.71875 2.74375 1.71875 5.625V9.375C1.71875 12.2563 2.74375 13.2812 5.625 13.2812H9.375C12.2563 13.2812 13.2812 12.2563 13.2812 9.375V6.25C13.2812 5.99375 13.4937 5.78125 13.75 5.78125C14.0063 5.78125 14.2188 5.99375 14.2188 6.25V9.375C14.2188 12.7688 12.7688 14.2188 9.375 14.2188Z"
                                                            fill="#1B9C85"/>
                                                        <path
                                                            d="M13.75 6.71875H11.25C9.1125 6.71875 8.28125 5.88749 8.28125 3.74999V1.24999C8.28125 1.06249 8.39375 0.887493 8.56875 0.818743C8.74375 0.743743 8.94375 0.787493 9.08125 0.918743L14.0813 5.91874C14.2125 6.04999 14.2563 6.25625 14.1813 6.43125C14.1063 6.60625 13.9375 6.71875 13.75 6.71875ZM9.21875 2.38124V3.74999C9.21875 5.36249 9.6375 5.78124 11.25 5.78124H12.6188L9.21875 2.38124Z"
                                                            fill="#1B9C85"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_769_518">
                                                            <rect width="15" height="15" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <p>{NumericFunction.e2p(v?.AC)}</p>
                                            </div>

                                            <div className="one-svg-box">
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M7.49969 10.2062C6.00596 10.2062 4.79346 8.99369 4.79346 7.49994C4.79346 6.0062 6.00596 4.7937 7.49969 4.7937C8.99344 4.7937 10.2059 6.0062 10.2059 7.49994C10.2059 8.99369 8.99344 10.2062 7.49969 10.2062ZM7.49969 5.7312C6.52469 5.7312 5.73096 6.52494 5.73096 7.49994C5.73096 8.47494 6.52469 9.26869 7.49969 9.26869C8.47469 9.26869 9.26844 8.47494 9.26844 7.49994C9.26844 6.52494 8.47469 5.7312 7.49969 5.7312Z"
                                                        fill="#32A692"/>
                                                    <path
                                                        d="M7.50031 13.1375C5.15029 13.1375 2.93154 11.7625 1.40654 9.375C0.744043 8.34375 0.744043 6.6625 1.40654 5.62499C2.93779 3.23749 5.15654 1.86249 7.50031 1.86249C9.84406 1.86249 12.0628 3.23749 13.5878 5.62499C14.2503 6.65625 14.2503 8.3375 13.5878 9.375C12.0628 11.7625 9.84406 13.1375 7.50031 13.1375ZM7.50031 2.79999C5.48154 2.79999 3.55029 4.01249 2.20029 6.13124C1.73154 6.8625 1.73154 8.1375 2.20029 8.86875C3.55029 10.9875 5.48154 12.2 7.50031 12.2C9.51906 12.2 11.4503 10.9875 12.8003 8.86875C13.2691 8.1375 13.2691 6.8625 12.8003 6.13124C11.4503 4.01249 9.51906 2.79999 7.50031 2.79999Z"
                                                        fill="#32A692"/>
                                                </svg>
                                                <p>{NumericFunction.e2p(v?.BC)}</p>
                                            </div>

                                            <div className="one-svg-box">
                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_769_512)">
                                                        <path
                                                            d="M9.375 14.2188H5.625C2.23125 14.2188 0.78125 12.7688 0.78125 9.375V5.625C0.78125 2.23125 2.23125 0.78125 5.625 0.78125H9.375C12.7688 0.78125 14.2188 2.23125 14.2188 5.625V9.375C14.2188 12.7688 12.7688 14.2188 9.375 14.2188ZM5.625 1.71875C2.74375 1.71875 1.71875 2.74375 1.71875 5.625V9.375C1.71875 12.2563 2.74375 13.2812 5.625 13.2812H9.375C12.2563 13.2812 13.2812 12.2563 13.2812 9.375V5.625C13.2812 2.74375 12.2563 1.71875 9.375 1.71875H5.625Z"
                                                            fill="#32A692"/>
                                                        <path
                                                            d="M6.61195 9.73756C6.48695 9.73756 6.3682 9.68756 6.2807 9.60006L4.51191 7.83131C4.33066 7.65006 4.33066 7.35006 4.51191 7.16881C4.69316 6.98756 4.99316 6.98756 5.17441 7.16881L6.61195 8.60631L9.82444 5.39381C10.0057 5.21256 10.3057 5.21256 10.4869 5.39381C10.6682 5.57506 10.6682 5.87506 10.4869 6.05631L6.9432 9.60006C6.8557 9.68756 6.73695 9.73756 6.61195 9.73756Z"
                                                            fill="#32A692"/>
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_769_512">
                                                            <rect width="15" height="15" fill="white"/>
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                                <p>{NumericFunction.e2p(v?.CC)}</p>
                                            </div>
                                        </div>

                                    </div>

                                    <p>ارجاع به : {v?.KMO_ERJA}</p>

                                    <div className="title-box">
                                        <svg width="7" height="7" viewBox="0 0 7 7" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="3.5" cy="3.5" r="3.5" fill={v?.colorId}/>
                                        </svg>
                                        <h4>{v?.AL_TXT}</h4>
                                    </div>

                                    <p>{v?.TZ}</p>

                                    <div className="link-box">
                                        {v?.fileUrl !== "" &&
                                            <>
                                                <a href={v?.fileUrl} target="blank">فایل بارگزاری شده</a>
                                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M9.27425 15.7832C8.36592 15.7832 7.45759 15.4416 6.76589 14.7499C5.38255 13.3666 5.38255 11.1249 6.76589 9.74158L8.83259 7.68325C9.07425 7.44158 9.47425 7.44158 9.71592 7.68325C9.95759 7.92491 9.95759 8.32491 9.71592 8.56658L7.64925 10.6249C6.75755 11.5166 6.75755 12.9749 7.64925 13.8666C8.54092 14.7582 9.99925 14.7582 10.8909 13.8666L14.1326 10.6249C15.1159 9.64158 15.6576 8.33325 15.6576 6.94158C15.6576 5.54988 15.1159 4.24155 14.1326 3.25821C12.0993 1.22488 8.79925 1.22488 6.76589 3.25821L3.23255 6.79158C2.40755 7.61658 1.94922 8.71658 1.94922 9.88325C1.94922 11.0499 2.40755 12.1499 3.23255 12.9749C3.47422 13.2166 3.47422 13.6166 3.23255 13.8582C2.99089 14.0999 2.59089 14.0999 2.34922 13.8582C1.29089 12.7916 0.699219 11.3832 0.699219 9.88325C0.699219 8.38325 1.28255 6.96658 2.34922 5.90821L5.88255 2.37488C8.39925 -0.141786 12.4993 -0.141786 15.0159 2.37488C16.2326 3.59155 16.9076 5.21655 16.9076 6.94158C16.9076 8.66658 16.2326 10.2916 15.0159 11.5082L11.7743 14.7499C11.0826 15.4416 10.1826 15.7832 9.27425 15.7832Z"
                                                        fill="#B9B9B9"/>
                                                </svg>
                                            </>}
                                    </div>
                                </div>
                            )}
                        </div>
                        : <p className="no-follow-list">پیگیری برای این قسمت تعریف نشده</p>}

                    <div className="button-list">

                        <button className="add-button" onClick={() => setShowFollowUplModal(true)}>افزودن</button>
                        {initialData.length > 0 && <>
                            <button className="solid-border" onClick={endTrackingHandler}>اتمام پیگیری</button>
                            <button className="solid-border" onClick={detailHandler}>جزییات</button>
                            <button className="delete-button" onClick={deleteHandler}>حذف</button>
                        </>}

                    </div>
                </div>
                : <Loader/>}
        </>
    );
};
export default FollowUpList;